import React from "react";
import PropTypes from "prop-types";

import Framework from "@beardeddevops/react.framework";
import {Types} from "components/index";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import moment from "moment";
import API from "@beardeddevops/react.api";
import ReactTable from "react-table";


/**
 *  @property {Tickets_Object} state
 *  @property {object} model
 *  @property {Tickets_Properties} model.properties
 *  @property {Tickets_Is} model.is
 *  @property {Tickets_Has} model.has
 */
export default class CalendarLogModal extends Framework.Components.Collection {

	constructor(props) {
		let model = new API.BuildClass(Types.Calendar_Logs._name, API.RequestType.READ_ALL);
		model.parent = props.parent;
		super(props, model);
		props.parent ? this.request = "GET" : null;
	}


	render() {
		let columns;
		const {data, pages, limit, loading} = this.state;
		columns = [
			{
				Header: "Date Changed",
				id: "date",
				/** @param {Calendar_Logs_Object} obj */
				accessor: obj => {
					return obj.date ? moment(obj.date).local().format("MM/DD/YYYY") : '-'
				}
			},
			{
				Header: "User",
				id: "users.name_last",
				/** @param {Calendar_Logs_Object} obj */
				accessor: obj => (obj.users ? (obj.users.name_first + " " + obj.users.name_last) : "Admin")
			},
			{
				Header: "Field",
				id: "field",
				/** @param {Calendar_Logs_Object} obj */
				accessor: obj => (obj.field.replace("_", " "))
			},
			{
				Header: "Original",
				id: "value_original",
				/** @param {Calendar_Logs_Object} obj */
				accessor: obj => (obj.display_original ? obj.display_original : (obj.value_original ? obj.value_original : "Blank"))
			},
			{
				Header: "New",
				id: "value_new",
				/** @param {Calendar_Logs_Object} obj */
				accessor: obj => (obj.display_new ?? obj.value_new)
			},
			{
				Header: "Note",
				id: "note",
				/** @param {Calendar_Logs_Object} obj */
				accessor: obj => (obj.note)
			}
		];

		return (
			<Card>
				<CardContent>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						onPageSizeChange={this.onPageSizeChange}
						onSortedChange={this.onSortedChange}
						page={this.state.page}
						onPageChange={this.onPageChange}
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						pageSize={limit}
						pageSizeOptions={[5, 20, 50, 100, 500, 1000]}
						className="-striped -highlight"
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}

}
